module.exports = __webpack_public_path__ + "img/9.4cb54689.svg";